import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import SemesterHeader from "./SemesterHeader";
import SemesterTable from "./SemesterTable";

const SemesterList = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <SemesterHeader />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <SemesterTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default SemesterList;
